export default "__VITE_ASSET__BL1S7wMD__"